<!-- Modal Header -->
<div class="modal-header">
    <h5 class="modal-title">
        <i class="ti ti-building me-2"></i>
        Detalhes da Empresa
    </h5>
    <button type="button" class="btn-close" (click)="goBack()"></button>
</div>

<!-- Modal Body -->
<div class="modal-body">
    @if (company) {
        <!-- Header com nome da empresa e badges -->
    <div class="card mb-3">
        <div class="card-body">
            <div class="d-flex justify-content-between align-items-start">
                <div class="flex-grow-1">
                    <div class="d-flex align-items-center gap-3 mb-3">
                        <div class="avatar bg-dark text-white rounded d-flex align-items-center justify-content-center" style="width: 56px; height: 56px; font-size: 24px;">
                            <i class="ti ti-building"></i>
                        </div>
                        <div>
                            <h3 class="mb-1">{{ company.name }}</h3>
                            @if (company.fantasyName) {
                                <p class="text-muted mb-1 small"><i class="ti ti-tag me-1"></i>{{ company.fantasyName }}</p>
                            }
                            <p class="text-muted mb-0 cursor-pointer" (click)="copy(company.documentNumber)">{{ company.documentNumber | cpfCnpj }}   <i class="ti ti-copy"></i></p>
                        </div>
                    </div>

                    <div class="d-flex gap-2 flex-wrap">
                        <span class="badge bg-light text-dark border">
                            <i class="ti ti-id me-1"></i>
                            {{ PersonTypeHelper.getLabel(company.personType) }}
                        </span>
                        @if (company.companySize) {
                            <span class="badge bg-light text-dark border">
                                <i class="ti ti-building-community me-1"></i>
                                {{ company.companySize }}
                            </span>
                        }
                        @if (company.registrationStatus) {
                            <span class="badge bg-dark text-white">
                                <i class="ti ti-file-check me-1"></i>
                                {{ company.registrationStatus }}
                            </span>
                        }
                        @if (company.dataSource) {
                            <span class="badge bg-light text-dark border">
                                <i class="ti ti-database me-1"></i>
                                {{ company.dataSource }}
                            </span>
                        }
                    </div>
                </div>

                @if (company.totalDebt && company.totalDebt > 0) {
                    <div class="text-end ms-3">
                        <small class="text-muted d-block mb-1">Dívida Total</small>
                        <h4 class="mb-1">{{ company.totalDebt | currency:'BRL' }}</h4>
                        @if (company.overdueInstallments && company.overdueInstallments > 0) {
                            <small class="text-muted">
                                <i class="ti ti-alert-circle"></i>
                                {{ company.overdueInstallments }} parcela(s) em atraso
                            </small>
                        }
                    </div>
                }
            </div>
        </div>
    </div>

    <div class="row">
        <!-- Coluna Principal -->
        <div class="col-lg-8">
            <!-- Endereço -->
            <div class="card mb-3">
                <div class="card-header">
                    <h6 class="mb-0">
                        <i class="ti ti-map-pin me-2"></i>
                        Endereço
                    </h6>
                </div>
                <div class="card-body">
                    @if (getFullAddress() !== '—') {
                        <p class="mb-0">{{ getFullAddress() }}</p>
                    } @else {
                        <p class="text-muted mb-0">
                            <i class="ti ti-info-circle me-2"></i>
                            Endereço não informado
                        </p>
                    }
                </div>
            </div>

            <!-- Dados Cadastrais -->
            <div class="card mb-3">
                <div class="card-header">
                    <h6 class="mb-0">
                        <i class="ti ti-clipboard-list me-2"></i>
                        Dados Cadastrais
                    </h6>
                </div>
                <div class="card-body">
                    @if (company.legalNature || company.startDate || company.shareCapital || company.registrationStatusDate || company.specialSituation || company.registrationStatusReason) {
                        <table class="table table-sm mb-0">
                            <tbody>
                                @if (company.legalNature) {
                                    <tr>
                                        <td class="text-muted" style="width: 40%">Natureza Jurídica</td>
                                        <td class="fw-semibold">{{ company.legalNature }}</td>
                                    </tr>
                                }
                                @if (company.startDate) {
                                    <tr>
                                        <td class="text-muted">Data de Início</td>
                                        <td class="fw-semibold">{{ company.startDate | date:'dd/MM/yyyy' }}</td>
                                    </tr>
                                }
                                @if (company.shareCapital) {
                                    <tr>
                                        <td class="text-muted">Capital Social</td>
                                        <td class="fw-semibold">{{ company.shareCapital | currency}}</td>
                                    </tr>
                                }
                                @if (company.registrationStatusDate) {
                                    <tr>
                                        <td class="text-muted">Data da Situação</td>
                                        <td class="fw-semibold">{{ company.registrationStatusDate | date:'dd/MM/yyyy' }}</td>
                                    </tr>
                                }
                                @if (company.specialSituation) {
                                    <tr>
                                        <td class="text-muted">Situação Especial</td>
                                        <td class="fw-semibold">{{ company.specialSituation }}</td>
                                    </tr>
                                }
                                @if (company.registrationStatusReason) {
                                    <tr>
                                        <td class="text-muted">Motivo Situação</td>
                                        <td class="fw-semibold">{{ company.registrationStatusReason }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    } @else {
                        <p class="text-muted mb-0">
                            <i class="ti ti-info-circle me-2"></i>
                            Informação não disponível
                        </p>
                    }
                </div>
            </div>

            <!-- Contato -->
            <div class="card mb-3">
                <div class="card-header">
                    <h6 class="mb-0">
                        <i class="ti ti-phone me-2"></i>
                        Contato
                    </h6>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            @if (company.email) {
                                <div class="d-flex align-items-center mb-3">
                                    <i class="ti ti-mail me-2"></i>
                                    <a [href]="'mailto:' + company.email" class="text-decoration-none">
                                        {{ company.email }}
                                    </a>
                                </div>
                            }

                            @if (company.phones && company.phones.length > 0) {
                                <div class="mb-2">
                                    <strong class="d-block mb-2">
                                        <i class="ti ti-phone me-1"></i>
                                        Telefones:
                                    </strong>
                                    @for (phone of company.phones; track $index) {
                                        <div class="d-flex align-items-center mb-2 ms-3">
                                            <app-phone [areaCode]="phone.ddd" [phone]="phone.number" [isFax]="phone.isFax"/>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>

                    @if (!company.email && (!company.phones || company.phones.length === 0)) {
                        <p class="text-muted mb-0">
                            <i class="ti ti-info-circle me-2"></i>
                            Informações de contato não disponíveis
                        </p>
                    }
                </div>
            </div>

            <!-- Atividades -->
            @if (company.mainActivity?.length || company.secondaryActivity?.length) {
                <div class="card mb-3">
                    <div class="card-header">
                        <h6 class="mb-0">
                            <i class="ti ti-briefcase me-2"></i>
                            Atividades
                        </h6>
                    </div>
                    <div class="card-body">
                        @if (company.mainActivity?.length) {
                            <strong class="d-block mb-2 small text-uppercase text-muted">Principal</strong>
                            @for (activity of company.mainActivity; track activity.id) {
                                <div class="d-flex align-items-start gap-2 mb-2">
                                    <span class="badge bg-light text-dark border flex-shrink-0">{{ activity.id }}</span>
                                    <span class="small">{{ activity.description }}</span>
                                </div>
                            }
                        }
                        @if (company.secondaryActivity?.length) {
                            <strong class="d-block mb-2 mt-3 small text-uppercase text-muted">Secundárias</strong>
                            @for (activity of company.secondaryActivity; track activity.id) {
                                <div class="d-flex align-items-start gap-2 mb-2">
                                    <span class="badge bg-light text-dark border flex-shrink-0">{{ activity.id }}</span>
                                    <span class="small">{{ activity.description }}</span>
                                </div>
                            }
                        }
                    </div>
                </div>
            }

            <!-- Simples Nacional -->
            @if (company.simples) {
                <div class="card mb-3">
                    <div class="card-header">
                        <h6 class="mb-0">
                            <i class="ti ti-receipt me-2"></i>
                            Simples Nacional
                        </h6>
                    </div>
                    <div class="card-body">
                        <table class="table table-sm mb-0">
                            <tbody>
                                <tr>
                                    <td class="text-muted" style="width: 40%">Status</td>
                                    <td class="fw-semibold">{{ company.simples.simples }}</td>
                                </tr>
                                @if (company.simples.dataOpcao) {
                                    <tr>
                                        <td class="text-muted">Data Opção</td>
                                        <td class="fw-semibold">{{ company.simples.dataOpcao | date:'dd/MM/yyyy' }}</td>
                                    </tr>
                                }
                                @if (company.simples.dataExclusao) {
                                    <tr>
                                        <td class="text-muted">Data Exclusão</td>
                                        <td class="fw-semibold">{{ company.simples.dataExclusao | date:'dd/MM/yyyy' }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            }

            <!-- Inscrições Estaduais -->
            @if (company.stateRegistrations?.length) {
                <div class="card mb-3">
                    <div class="card-header">
                        <h6 class="mb-0">
                            <i class="ti ti-file-certificate me-2"></i>
                            Inscrições Estaduais
                        </h6>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-sm mb-0">
                                <thead>
                                <tr>
                                    <th>UF</th>
                                    <th>Inscrição</th>
                                    <th>Status</th>
                                </tr>
                                </thead>
                                <tbody>
                                    @for (reg of company.stateRegistrations; track reg.stateRegistration) {
                                        <tr>
                                            <td>{{ reg.state }}</td>
                                            <td>{{ reg.stateRegistration }}</td>
                                            <td>
                                                @if (reg.isActive) {
                                                    <span class="badge bg-success">Ativa</span>
                                                } @else {
                                                    <span class="badge bg-secondary">Inativa</span>
                                                }
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            }

            <!-- Quadro Societário -->
            <div class="card mb-3">
                <div class="card-header">
                    <h6 class="mb-0">
                        <i class="ti ti-users me-2"></i>
                        Quadro Societário
                    </h6>
                </div>
                <div class="card-body">
                    @if (company.partners && company.partners.length > 0) {
                        <div class="table-responsive">
                            <table class="table table-sm mb-0">
                                <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Qualificação</th>
                                    <th>CPF/CNPJ</th>
                                    <th>Entrada</th>
                                </tr>
                                </thead>
                                <tbody>
                                    @for (partner of company.partners; track $index) {
                                        <tr>
                                            <td>
                                                <div>{{ partner.name }}</div>
                                                @if (partner.ageRange) {
                                                    <small class="text-muted">{{ partner.ageRange }}</small>
                                                }
                                            </td>
                                            <td>
                                                <span class="badge bg-light text-dark border">
                                                    {{ partner.qualification }}
                                                </span>
                                            </td>
                                            <td>
                                                <small class="text-muted">
                                                    {{ partner.cpfCnpj }}
                                                </small>
                                            </td>
                                            <td>
                                                @if (partner.entryDate) {
                                                    <small>{{ partner.entryDate | date:'dd/MM/yyyy' }}</small>
                                                } @else {
                                                    <small class="text-muted">—</small>
                                                }
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    } @else {
                        <p class="text-muted mb-0">
                            <i class="ti ti-info-circle me-2"></i>
                            Informação não disponível
                        </p>
                    }
                </div>
            </div>

            <!-- Informações do Sistema -->
            @if (company.createdAt || company.updatedAt) {
                <div class="card">
                    <div class="card-body">
                        <div class="row text-center">
                            @if (company.createdAt) {
                                <div class="col-6">
                                    <small class="text-muted d-block mb-1">Cadastrado em</small>
                                    <strong>{{ company.createdAt | date:'dd/MM/yyyy' }}</strong>
                                    <br>
                                    <small class="text-muted">{{ company.createdAt | date:'HH:mm' }}</small>
                                </div>
                            }
                            @if (company.updatedAt) {
                                <div class="col-6">
                                    <small class="text-muted d-block mb-1">Atualizado em</small>
                                    <strong>{{ company.updatedAt | date:'dd/MM/yyyy' }}</strong>
                                    <br>
                                    <small class="text-muted">{{ company.updatedAt | date:'HH:mm' }}</small>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>

        <!-- Coluna Lateral - Ações -->
        <div class="col-lg-4">
            <!-- Resumo Financeiro -->
            @if (company.estimatedDebtValue || company.totalInstallmentRemaining) {
                <div class="card mb-3">
                    <div class="card-header">
                        <h6 class="mb-0">
                            <i class="ti ti-file-invoice me-2"></i>
                            Resumo Financeiro
                        </h6>
                    </div>
                    <div class="card-body">
                        @if (company.estimatedDebtValue) {
                            <div class="text-center mb-3 pb-3 border-bottom">
                                <small class="text-muted d-block mb-2">Saldo Devedor (Estimado)</small>
                                <h3 class="mb-0">{{ company.estimatedDebtValue | currency:'BRL' }}</h3>
                            </div>
                        }

                        @if (company.totalInstallmentRemaining && company.totalInstallmentRemaining > 0) {
                            <div class="text-center mb-3">
                                <small class="text-muted d-block mb-2">Parcelas Restantes</small>
                                <h4 class="mb-0">
                                    <span class="badge bg-light text-dark border" style="font-size: 1.25rem; padding: 0.5rem 1rem;">
                                        {{ company.totalInstallmentRemaining }}
                                    </span>
                                </h4>
                            </div>
                        }
                    </div>
                </div>
            }

            <!-- Ações Rápidas -->
            <div class="card">
                <div class="card-header">
                    <h6 class="mb-0">
                        <i class="ti ti-bolt me-2"></i>
                        Ações Rápidas
                    </h6>
                </div>
                <div class="card-body">
                    <div class="d-grid gap-2">
                        <button class="btn btn-dark" (click)="viewDebts()">
                            <i class="ti ti-file-invoice me-2"></i>
                            Ver Parcelamentos PGFN
                        </button>
                        <button class="btn btn-secondary" (click)="goToSisparPage()">
                            <i class="ti ti-globe me-2"></i>
                            Acessar SISPARNET
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    } @else {
        <div class="text-center py-5">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="text-muted mt-2">Carregando...</p>
        </div>
    }
</div>

<!-- Modal Footer -->
<div class="modal-footer">
    @if (company?.documentNumber && PersonTypeHelper.isPJ(company?.personType)) {
        <button class="btn btn-outline-dark" (click)="enrichByDocumentNumber(company.documentNumber)">
            <i class="ti ti-refresh me-2"></i>
            Atualizar Dados
        </button>
    }
    <button class="btn btn-secondary" (click)="goBack()">
        Fechar
    </button>
</div>
